import { render, staticRenderFns } from "./VBaseCardAjaxList.vue?vue&type=template&id=73759056&scoped=true"
import script from "./VBaseCardAjaxList.vue?vue&type=script&lang=js"
export * from "./VBaseCardAjaxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73759056",
  null
  
)

export default component.exports